import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import CommonUtil from "../../util/CommonUtils";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import i18n from "../../config/i18n";

export default function CheckToken(props) {
  let navigate = useNavigate();
  const { t, ready } = useTranslation();

  function isTokenExpired(token) {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp < currentTime;
    } catch (e) {
      return true;
    }
  }

  function showError() {
    if (i18n.isInitialized) {
      toast.error(i18n.t("RAL0775"));
    } else {
      i18n.on("initialized", () => {
        toast.error(i18n.t("RAL0775"));
      });
    }
  }

  const validateToken = async () => {
    props.setLoading(true);
    var accessToken = CommonUtil.getCookie("token");
    var refreshToken = CommonUtil.getCookie("refresh_token");
    var sessionExpire = localStorage.getItem("login_session");

    if (
      !CommonUtil.isEmptyString(sessionExpire) &&
      sessionExpire === "expired"
    ) {
      // toast.error(t("RAL0775"));
      showError();
      CommonUtil.resetUserSession();
      localStorage.removeItem("login_session");      
      props.setLoading(false);
      return;
    }

    if (accessToken && refreshToken) {
      if (isTokenExpired(accessToken)) {
        console.log("Access token has expired");
        var expTime = CommonUtil.getCookie("expTime");

        if (!expTime) {
          // toast.error(t("RAL0775"));
          CommonUtil.resetUserSession();
          return;
        }

        if (!isTokenExpired(refreshToken)) {
          console.log("Refreshing access token...");
          setRefreshToken(refreshToken);
        } else {
          // toast.error(t("RAL0775"));
          CommonUtil.resetUserSession();
        }
      } else {
        localStorage.setItem("token",accessToken);
        localStorage.setItem("refresh_token",refreshToken);
        console.log("Access token is valid. Proceed.");
        navigate("/dashboard");
      }
    }
    props.setLoading(false);
  };

  useEffect(() => {
    validateToken();
  }, []);

  const setRefreshToken = async () => {
    var decoded_jwtToken = jwtDecode(CommonUtil.getCookie("token"));
    var payload = {
      refreshToken: CommonUtil.getCookie("refresh_token").replace(
        "Bearer ",
        ""
      ),
      companyCode: decoded_jwtToken.companyCode,
    };
    const settings = {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: CommonUtil.getCookie("token"),
      },
      body: JSON.stringify(payload),
    };
    try {
      const fetchResponse = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/user/authorize/refresh_token`,
        settings
      );
      const res = await fetchResponse.json();
      if (res.code === "UASI0011") {
        console.log("Refreshed token @" + new Date());
        localStorage.setItem("token", "Bearer " + res.data.access_token);
        localStorage.setItem(
          "refresh_token",
          "Bearer " + res.data.refresh_token
        );
        CommonUtil.setCookie("token", "Bearer " + res.data.access_token, 1);
        CommonUtil.setCookie(
          "refresh_token",
          "Bearer " + res.data.refresh_token,
          1
        );
        const decoded = jwtDecode(res.data.access_token);
        localStorage.setItem("USER", JSON.stringify(decoded));
        navigate("/dashboard");
      } else {
        showError();
      }
    } catch (e) {
      console.log("error", e);
      return e;
    }
    finally{
      props.setLoading(false);
    }
  };

  return <></>;
}
